module.exports = __webpack_public_path__ + "front/img/z3.40472cf4.jpg";